import {
  Box,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import SocialBtns from 'lib/social/social_btns';

export interface MtSnsProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SnsModal(props: MtSnsProps) {
  const { isOpen, onClose } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w={'315px'} px={0} mx={0} mt={'300px'}>
        <ModalHeader p={0} m={0} py={'28px'}>
          <Box position={'relative'}>
            <Center fontSize={'18px'} fontWeight="semibold">
              로그인
            </Center>
            <ModalCloseButton
              right={'15px'}
              top={0}
              w={'24px'}
              h={'24px'}
              onClick={onClose}
            />
          </Box>
        </ModalHeader>
        <ModalBody pt={'0px'} pb={'28px'} px={'14px'}>
          <SocialBtns />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
